const dateString = (date: Date) => {
  if (!date) {
    return;
  }
  return date.toISOString().slice(0, 10);
};

export default dateString;
